const PageNotFound = () => {
  return (
    <>
      <p className="flex justify-center mt-24 font-serif text-xl">
        ⚠️Error 404: Page Not Found⚠️
      </p>
    </>
  );
};

export default PageNotFound;
